import { createSlice } from '@reduxjs/toolkit';

// project imports
import { dispatch } from '../index';
import apiSlice from './apiSlice';
import menuItems from 'menu-items';

// initial state
const initialState = {
    selectedItem: ['dashboard'],
    selectedID: null,
    drawerOpen: false,
    error: null,
    menu: {}
};

// ==============================|| SLICE - MENU ||============================== //

const menu = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        activeItem(state, action) {
            state.selectedItem = action.payload;
        },

        activeID(state, action) {
            state.selectedID = action.payload;
        },

        openDrawer(state, action) {
            state.drawerOpen = action.payload;
        },

        // has error
        hasError(state, action) {
            state.error = action.payload;
        },

        // get dashboard menu
        getMenuSuccess(state, action) {
            state.menu = action.payload;
        }
    }
});

export default menu.reducer;

export const { activeItem, openDrawer, activeID } = menu.actions;

export function getMenu() {
    return async (dispatch) => {
        const enableMenuApi = process.env.REACT_APP_MENU_API === 'true';
        if (enableMenuApi) {
            try {
                const result = await dispatch(apiSlice.endpoints.getMenuWidget.initiate(undefined)).unwrap();
                dispatch(menu.actions.getMenuSuccess(result?.widget ?? result));
                return;
            } catch (error) {
                const status = error?.status ?? error?.response?.status;
                if (status === 401) {
                    // Không redirect cứng; AuthGuard sẽ xử lý khi isLoggedIn false
                    dispatch(menu.actions.hasError(error));
                    return;
                }
                dispatch(menu.actions.hasError(error));
            }
        }
        dispatch(
            menu.actions.getMenuSuccess({
                id: 'widget',
                title: 'widget',
                icon: 'widget',
                children: menuItems.items || []
            })
        );
    };
}
